import React, {
  createContext,
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import { connect } from "../../atoms/DependencyHelper";
import NumberTransferTypes from "../../molecules/NumberTransfer/NumberTransferTypes";
import { NumberTransferTypes as TransferTypes } from "../../../config/constants";
import { useDispatch, useSelector } from "react-redux";
import NumberTransferInfoBox from "../../molecules/NumberTransfer/NumberTransferInfoBox";
import NumberTransferNumber from "../../molecules/NumberTransfer/NumberTransferNumber";
import GeneralInfoBox from "../../molecules/NumberTransfer/GeneralInfoBox";
import { journeyType } from "../../../context/checkout-journey-context";
import * as Analytics from "../../../services/analyticsUtag";
import styles from "./numberTransfer.module.scss";
import ajaxServices from "../../../utils/ajaxServices";
import defaultTexts from "./numberTransferCbu";
import { setNumberTransferDetails } from "../../../Redux/actions/checkoutAction";
import { NumberTransferTypes as NumberTransferOptions } from "../../../config/constants";
import microService from "../../../utils/microServices";

export const NumberTransferCBU = createContext({});

// eslint-disable-next-line react/display-name
const NumberTransfer = forwardRef(
  (
    {
      continueDisable,
      setShowSnackBar,
      navigate,
      handleHeading,
      customerStatus,
      currentJourneyType,
      multicartFlag,
    },
    ref
  ) => {
    const dispatch = useDispatch();
    const active = useSelector(
      ({ checkoutDetails }) => checkoutDetails.numberTransferType
    );
    const details = useSelector(
      ({ checkoutDetails }) => checkoutDetails.numberTransferDetails
    );

    const [content, setContent] = useState("");
    const [isContactMeChecked, setIsContactMeChecked] = useState(false);

    useEffect(() => {
      dispatch(setNumberTransferDetails({}));
      Analytics.view({
        page_event: "view",
        multicart_flag: multicartFlag ? true : false,
        page_name: `checkout: number transfer: ${customerStatus}`,
        ...Analytics.getUtagData([
          "page_channel",
          "page_master_tab",
          "visitor_login_status",
          "visitor_customer_id",
          "visitor_id_hash",
          "visitor_msisdn_hash",
          "visitor_subscription_type",
        ]),
      });
      let texts = {};
      ajaxServices
        .httpGet("drupalBaseUrl", "", "api", "numberTransferPage")
        .then((numberTransferResponse) => {
          texts = numberTransferResponse;
        })
        .catch(() => {
          texts = defaultTexts;
        })
        .finally(() => {
          setContent(texts);
          handleHeading("update", "desc", texts?.sections[0]?.description);
          handleHeading("update", "title", texts?.sections[0]?.title);
        });
    }, []);

    useEffect(() => {
      continueDisable(
        details.success === undefined && active !== TransferTypes.NEW_NUMBER
      );
      handleHeading(details.success === undefined ? "show" : "hide", "desc");
    }, [details, active]);

    useImperativeHandle(ref, () => ({
      submit: () => {
        Analytics.link({
          link_type: "o",
          link_name: `checkout: number transfer: ${customerStatus}: continue`,
        });

        if (isContactMeChecked) {
          // create a number transfer lead
          submitLeadFormInSilent();
        }

        navigate("delivery");
      },
      back: () => {
        if (
          currentJourneyType == journeyType.newLine ||
          currentJourneyType == journeyType.addLine
        ) {
          Analytics.link({
            link_type: "o",
            link_name: `checkout: number transfer: ${customerStatus}: back to credit check`,
          });
        } else {
          Analytics.link({
            link_type: "o",
            link_name: `checkout: number transfer: ${customerStatus}: back to lets get started`,
          });
        }
      },
    }));

    const handleChange = (isChecked) => {
      setIsContactMeChecked(isChecked);
    };

    const userProfileData = useSelector(
      ({ navDetails }) => navDetails.profileData
    );

    const msisdnValue = useSelector(
      ({ checkoutDetails }) => checkoutDetails.numberToTransfer
    );

    const submitLeadFormInSilent = async () => {
      const inputObj = {
        channel: "ONLINE",
        emailAddress: userProfileData?.email,
        idDocType: "MSISDN",
        idNumber: msisdnValue,
        msisdn: msisdnValue,
        name: userProfileData?.firstname,
        requestType: "number_transfer",
        surname: userProfileData?.lastname,
      };

      await microService.post("api", "staticFormSubmit", inputObj, null, false);
    };

    return (
      <div className={styles["number-transfer-wrapper"]}>
        <NumberTransferCBU.Provider value={{ ...content, multicartFlag }}>
          {details.success !== undefined && (
            <GeneralInfoBox onChangeHandler={handleChange} />
          )}
          {details.success === undefined && (
            <NumberTransferTypes customerStatus={customerStatus} />
          )}
          {active !== NumberTransferOptions.NEW_NUMBER &&
            details.success !== false && <NumberTransferInfoBox />}
          {details.success === undefined && (
            <NumberTransferNumber
              setShowSnackBar={setShowSnackBar}
              currentJourneyType={currentJourneyType}
              navigate={navigate}
              customerStatus={customerStatus}
            />
          )}
        </NumberTransferCBU.Provider>
      </div>
    );
  }
);

export default connect(null, null, null, {
  forwardRef: true,
})(NumberTransfer);
